import React from 'react';
import { Route } from 'react-router-dom';
import ProductionReportList from './ProductionReportList';

const routes = () => [
  <Route path="/production-report" exact component={ProductionReportList} key="/production-report" />,
].map(route => route);

export default routes;
